<template>
  <div
    v-if="dispatch.isLoadedFirst.all"
    :class="[
      s.wrap,
      s[helper.displayDirection],
      `order_${helper.displayDirection}`,
      'order',
    ]">
    <div :class="s.content">
      <Timeline ref="timeline" />
      <div
        v-if="!items?.length"
        class="p-3 fw-bold">
        <div><i class="fa-solid fa-file me-3"/>現在、配車はありません。</div>
      </div>
      <swiper
        ref="order-slide"
        v-if="items?.length && flag.showSlider && (activeIndex || activeIndex === 0)"
        :slides-per-view="1"
        :space-between="0"
        :modules="modules"
        :pagination="false"
        :navigation="false"
        :centered-slides="true"
        :initial-slide="activeIndex"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        :class="s.card_container"
      >
        <swiper-slide
          v-for="(item, i) in items"
          :key="i"
          :class="[s.slide]"
          :style="slideStyle(item)">
          <component
            :is="templateName(item)"
            :isPriorityTop="Boolean(topPriortyItem?.id === item.raw.id)"
            :reservation="item.raw"
            :styleClasses="s"
          />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  LargeBtn,
  OrderDefault,
  OrderDemand,
  OrderDispatch,
  Timeline,
} from '@/components/parts';
import cf from '@/mixins/commonFunctions.js';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

export default {
  name: 'order  ',
  mixins: [cf],
  components: {
    LargeBtn,
    Swiper,
    SwiperSlide,
    OrderDefault,
    OrderDemand,
    OrderDispatch,
    Timeline,
  },
  data() {
    return {
      flag: {
        showSlider: true,
        resettingSlider: false,
      },
      recalclatePrice: 0,
      inputDestinationAddress: '',
      destinationSearchResult: {},
      sliderInitIdx: 0,
      message: '',
      unreadChatMessages: {},
      activeIndex: null,
      swiperInstance: null,
      scheduleItemsTimer: null,
    };
  },
  setup() {
    return {
      modules: [Pagination, Navigation],
    };
  },
  computed: {
    ...mapState(['user', 'helper', 'modal', 'dispatch']),
    itemLoaded() {
      return this.dispatch.isLoadedFirst.all;
    },
    scheduleItems() {
      return this.dispatch.scheduleItems;
    },
    driverReservations() {
      if (!this.user.orders || !this.user.orders.length) return [];
      // 日時順にソート
      return [...this.user.orders].sort((a, b) => new Date(a.reservation_time) - new Date(b.reservation_time));
    },
    topPriortyItem() {
      const notCompletedScheduleItems = this.scheduleItems
        .filter((item) => ['reservation', 'dispatch'].includes(item.type))
        .filter((item) => !this.isCompleted(item));
      return notCompletedScheduleItems.reduce((cur, acc) => (cur.start < acc.start ? cur : acc), notCompletedScheduleItems[0]);
    },
    items() {
      return this.scheduleItems.filter((item) => ['reservation', 'dispatch'].includes(item.type));
    },
    query() {
      return this.$route.query;
    },
  },
  watch: {
    itemLoaded: {
      handler() {
        this.setActiveIndex();
      },
    },
    query: {
      handler() {
        this.setActiveIndex();
      },
      deep: true,
    },
    activeIndex() {
      this.slideSwiper();
    },
  },
  mounted() {
    this.setActiveIndex();
  },
  methods: {
    setActiveIndex() {
      // 読み込み中 もしくは items がなければ読み込みフラグを切って return
      if (!this.itemLoaded || !this.items.length) return;
      // クエリと優先度からフォーカスするアイテムを特定
      const isValidQuery = this.items.find((item) => item.code === this.query.code && item.type === this.query.type);
      const { code, type } = isValidQuery ? this.$route.query : this.topPriortyItem || this.items[0];
      const index = this.items.findIndex((item) => item.type === type && item.code === code);
      this.activeIndex = index;
      this.scrollTimeline();
      if (this.query.type !== type || this.query.code !== code) this.$router.replace({ query: { code, type } });
    },
    isCompleted(item) {
      const COMPLETED_FLAG = 31;
      if (item.type === 'reservation') {
        if (item.raw.foreign_type === 31) return item.raw.demandCustomers.every((dc) => dc.flag >= COMPLETED_FLAG);
        return item.raw.order?.flag >= 31;
      }
      if (item.type === 'dispatch') return item.raw.passengers.every((p) => p.flag >= COMPLETED_FLAG);
      return true;
    },
    templateName(item) {
      if (item.type === 'dispatch') return 'OrderDispatch';
      return item.raw.foreign_type === 31 ? 'OrderDemand' : 'OrderDefault';
    },
    slideStyle(item) {
      if (!this.topPriortyItem || this.topPriortyItem.code !== item.code || this.topPriortyItem.type !== item.type) return {};
      return {
        border: '6px solid',
        borderColor: this.itemStatus(item, this.helper.master).color,
      };
    },
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    scrollTimeline() {
      const activeItem = this.items[this.activeIndex || 0];
      if (!activeItem) return;
      this.$nextTick(() => {
        if (this.$refs.timeline) this.$refs.timeline.scrollToTime(activeItem.start);
      });
    },

    /** 住所からLatLngを取得 */
    searchLocationFromAddress() {
      this.showLoading();
      this.axios({
        method: 'GET',
        url: '/v1/helper/get/latlng',
        params: { address: this.inputDestinationAddress },
      })
        .then((response) => {
          const res = response.data;
          if (res.isValid) {
            this.destinationSearchResult = {
              title: res.name,
              address: res.address,
              lat: res.latitude,
              lng: res.longitude,
            };
            this.inputDestinationAddress = '';
          } else {
            alert('位置が取得できませんでした。再度お試しください。');
          }
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    /** ２地点間の距離を取得 */
    async getDistanceDuration({
      pLat,
      pLng,
      dLat,
      dLng,
    }) {
      let distance = null;
      await this.axios({
        method: 'POST',
        url: '/v1/helper/get/distanceDuration',
        params: {
          p_lat: pLat,
          p_lng: pLng,
          d_lat: dLat,
          d_lng: dLng,
          noGenerateMap: true,
        },
      })
        .then((response) => {
          const res = response.data;
          if (res.distance) distance = res.distance;
          else alert('距離計算中にエラーが発生しました。再度お試しください。');
        })
        .catch((error) => {
          console.log(error);
          alert('距離計算中にエラーが発生しました。再度お試しください。');
        });
      return distance;
    },

    async calculateFare(params) {
      let fare = null;
      await this.axios({
        method: 'POST',
        url: '/v1/helper/get/calcTaxiFare',
        data: params,
      })
        .then((response) => {
          const res = response.data;
          if (res.fare) fare = res.fare;
          else alert('エラーが発生しました。再度お試しください。');
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
        });
      return fare;
    },

    async calcFare(reservation) {
      this.showLoading();
      // 乗降車地点間の距離を取得
      const distance = await this.getDistanceDuration({
        pLat: reservation.p_lat,
        pLng: reservation.p_lng,
        dLat: this.destinationSearchResult.lat,
        dLng: this.destinationSearchResult.lng,
      });
      // 深夜割り増しの有無判定
      const isMidNight = new Date().getHours() >= 22 || new Date().getHours() < 5;

      if (distance) {
        const fare = await this.calculateFare({
          includePickupFee: false, // ライドシェアなので迎車は考慮しない
          pickupDistance: 0,
          allDistance: distance,
          isMidNight,
          isRideshare: true,
        });
        if (fare) {
          this.registDestination(reservation, fare);
        } else {
          alert('運賃計算中にエラーが発生しました。再度お試しください。');
          this.hideLoading();
        }
      } else {
        alert('乗降車地点間の距離の取得に失敗しました。再度お試しください。');
        this.hideLoading();
      }
    },

    registDestination(reservation, fare) {
      const data = { id: reservation.id };
      Object.keys(this.destinationSearchResult).forEach((key) => {
        data[`d_${key}`] = this.destinationSearchResult[key];
      });
      data.e_price = fare;
      this.axios({
        method: 'POST',
        url: '/v1/reservation/update',
        data,
      })
        .then(() => {
          this.$store.dispatch('user/update');
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    onSwiper(swiper) {
      this.swiperInstance = swiper;
    },
    slideSwiper() {
      if (this.activeIndex === null) return;

      const { type, code } = this.items[this.activeIndex];

      const targetIdx = this.items.findIndex((rsv) => rsv.code === code && rsv.type === type);
      if (targetIdx < 0) return;

      this.sliderInitIdx = targetIdx;
      this.activeIndex = targetIdx;
      if (this.swiperInstance) {
        if (this.swiperInstance.activeIndex !== targetIdx) {
          this.swiperInstance.slideTo(targetIdx);
        }
      }
    },
    onSlideChange(swiper) {
      this.activeIndex = swiper.activeIndex;
      const rsv = this.items[swiper.activeIndex];
      if (!rsv?.code) return;
      this.$router.replace({ query: { code: rsv.code, type: rsv.type } });
    },
  },
};
</script>

<style lang="scss">
.order {
  .swiper-button-prev, .swiper-button-next {
    bottom: 0; top: auto;
    width: 60px;
    height: 100%;
    border-radius: 4px;
    background-color: var(--bs-gray);
    &::after {
      font-size: 30px;
      color: #ffffff;
    }
  }
  .swiper-button-next {
    right: 0px;
  }
  .swiper-button-prev {
    left: 0px;
  }
  .swiper-button-disabled {
    opacity: 1;
    background-color: #dce1e5;
    border-color: rgba(#ffffff, .1) rgba(#000000, .05) rgba(#000000, .05) rgba(#ffffff, .1);
  }
  .swiper-button-lock {
    display: flex;
  }
}

.order_vertical {
  .swiper-button-prev, .swiper-button-next {
    bottom: 0; top: auto;
    width: 50%;
    height: 60px;
    &::after {
      font-size: 30px;
      color: #ffffff;
    }
  }
}
</style>

<style lang="scss" module="s">
.wrap {
  height: 100%;
  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

.card_container {
  flex: 1;
  width: 100%;
  .slide {
    height: 100%;
  }
}

.card {
  height: 100%;
  display: flex;
  flex-direction: column;
  &_header {
    border-bottom: 1px solid var(--border-gray);
    padding: 4px 12px;
    background-color: var(--bg-gray);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
  }
  &_body {
    flex: 1;
    padding: 0 12px;
    background-color: #ffffff;
    overflow: scroll;
    &_content {
      position: relative;
      height: fit-content;
      display: flex;
      height: 100%;
      padding: 12px 0;
      > :nth-child(1) {
        flex: 1;
        height: 100%;
        overflow: scroll;
      }
      > :nth-child(2) {
        height: 100%;
        width: 150px;
        display: flex;
        flex-direction: column;
        > * {
          height: auto;
          flex: 1;
          &:not(:first-child) {
            margin-top: 6px;
          }
        }
      }
    }
  }
}

.status_btns {
  height: 100%;
  margin-left: 12px;
}

.locations {
  > *:not(:first-child) {
    position: relative;
    margin-top: 12px;
    &::after {
      content: '';
      position: absolute;
      bottom: 100%;
      left: 12px;
      width: 8px;
      height: 12px;
      background-color: var(--border-gray);
    }
  }
}
.location {
  width: 100%;
  text-align: left;
  background-color: var(--bg-gray);
  border-radius: 4px;
  display: flex;
  align-items: stretch;
  > * {
    padding: 4px 8px;
  }
  > :nth-child(1) {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 30px;
    flex-shrink: 0;
    border-right: 1px solid var(--border-gray);
  }
  > :nth-child(2) {
    // text-decoration: underline;
    flex: 1;
  }
}
.buttons {
  display: flex;
  align-items: center;
  padding: 0 12px 12px;
}

.button {
  border: none;
  background-color: transparent;
  padding: 0 16px;
  height: 50px;
  font-weight: bold;
  border-radius: 4px;
  white-space: nowrap;
  &:disabled {
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: 0; left: 0;
      width: 100%;
      height: 100%;
      border-radius: 4px;
      background-color: rgba(#000000, .5);
      mix-blend-mode: multiply;
    }
  }
  &.blue {
    background-color: var(--primary-blue);
    color: white;
  }
  &.red {
    background-color: var(--primary-red);
    color: white;
  }
  &.green {
    background-color: var(--primary-green);
    color: white;
  }
  &.gray {
    background-color: var(--primary-gray);
    color: white;
  }
}
.price {
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  .label {
    background-color: var(--bg-gray);
    padding: 12px;
    font-weight: bold;
  }
  .value {
    padding: 12px 12px 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .num {
      display: flex;
      align-items: center;
      > :nth-child(2) {
        padding-left: 50px;
        position: relative;
        span {
          padding: 0 8px;
          background-color: var(--bg-pink);
          display: inline-block;
        }
        &::after {
          content: '→';
          position: absolute;
          top: 50%;
          left: 12px;
          transform: translateY(-50%);
        }
      }
    }
  }
}
.chat {
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  .label {
    background-color: var(--bg-gray);
    padding: 12px;
    font-weight: bold;
  }
  .form {
    padding: 12px;
    display: flex;
    align-items: stretch;
    height: fit-content;
    > textarea {
      flex: 1;
    }
    div {
      button {
        width: 120px !important;
        height: 100%;
        margin: 0;
        margin-left: 6px;
        &.clear {
          width: 50px !important;
          padding: 0;
        }
      }
    }
  }
  .unreadChat {
    position: relative;
    .chats {
      &:not(:first-child) >li {
        position: relative;
        &::before {
          content: "";
          position: absolute;
          top: -15px;
          left: 30px;
          width: 3px;
          height: 15px;
          background-color: #daeef2;
        }
        padding: 0 15px 15px 15px;
        &.q {
          &::before {
            background-color: #25db2e;
          }
        }
        &.a {
          &::before {
            background-color: #26aac7;
          }
        }
      }
      >li {
        padding: 15px;
      }
      .mWrap {
        padding: 15px;
        border-radius: 8px;
        background-color: #e2f5df;
      }
      .name {
        font-size: 14px;
      }
      .message {
        font-size: 16px;
        white-space: pre-wrap;
        word-break: break-all;
      }

      .question {
        background-color: #e2f5df;
      }
      .answer {
        background-color: #daeef2;
      }
    }
    .new {
      position: absolute;
      background-color: #f71c55;
      color: #fff;
      font-weight: bold;
      font-size: 14px;
      padding: 4px 12px;
      border-radius: 4px;
      top: 5px;
      right: 6px;
      &_wrap {
        position: relative;
      }
    }
  }
}
.templates {
  width: 100%;
  padding: 6px 12px 0 12px;
  display: flex;
  flex-wrap: wrap;
  > li {
    padding: 4px 12px;
    margin-top: 6px;
    margin-right: 6px;
  }
}

// windowサイズが縦長の時
.wrap.vertical {
  .content {}
  .card_container {}
  .card {
    &_body {
      overflow: hidden;
      &_content {
        flex-direction: column-reverse;
        padding: 0 0;
        height: 100%;
        > * {
          &:first-child {
            padding: 12px 0;
            flex: 1;
            > * {
              overflow: scroll;
            }
          }
        }
      }
    }
  }
  .status_btns {
    width: 100%;
    height: auto;
    margin-left: 0;
    flex-direction: row;
    background-color: #ffffff;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 12px;
    > * {
      flex: initial;
      flex-shrink: 0;
      width: calc((100% - 6px) / 2);
      height: 80px;
      &:not(:first-child) {
        margin-top: 0;
      }
      &:not(:nth-child(2n)) {
        margin-right: 6px;
      }
      &:nth-child(n + 3) {
        margin-top: 6px;
      }
    }
  }
}
</style>
